import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useStoryblokState } from "@cinch-nx/data-storyblok";
import { Head, renderWithResolver } from "@cinch-nx/landing-ui-shared";
import { Wrapper } from "@cinch-nx/shared-ui";
import { EvBenefits } from "./components/ev-benefits";
import { EvCharging } from "./components/ev-charging";
import { EvFaqs } from "./components/ev-faqs";
import { EvInfoCard } from "./components/ev-info-card";
import { EvPreFooter } from "./components/ev-pre-footer";
import { EvRange } from "./components/ev-range";
import { ExploreEvs } from "./components/explore-our-evs";
import { EvIntro } from "./components/intro/intro";
import { JargonBuster } from "./components/jargon-buster";
import styles from "./landing-feature-electric-cars.module.css";
import cx from "classnames";
import dynamic from "next/dynamic";
import { CompareBarProvider } from "@cinch-labs/shared-compare-cars";
import { useUserStore } from "@cinch-nx/data-user";
import { useFavouritesStore } from "@cinch-nx/data-favourites";
import { handlePostAuthFavourite } from "@cinch-labs/shared-auth-modal";
const SharedCompareBar = dynamic(()=>import("@cinch-labs/shared-compare-cars").then((module)=>module.CompareBar), {
    loadableGenerated: {
        webpack: ()=>[
                require.resolveWeak("@cinch-labs/shared-compare-cars")
            ]
    },
    ssr: false
});
export function FeatureElectricCars({ story , generatedAt , preview  }) {
    var ref;
    const { content  } = useStoryblokState({
        story,
        enableBridge: preview
    });
    const { status: userStatus  } = useUserStore();
    const { addFavourite  } = useFavouritesStore();
    const { intro , benefitsOfAnElectricCar , chargingAnElectricCar , electricCarRange , didYouKnow , electricCarsJargon , electricCarsFaqs , preFooter  } = content;
    const evChargingContent = chargingAnElectricCar[0];
    const evRangeContent = electricCarRange[0];
    const evJargonContent = electricCarsJargon[0];
    const { title: faqTitle , faqs  } = electricCarsFaqs[0];
    const { evCta , image  } = preFooter[0];
    const SEO = content === null || content === void 0 ? void 0 : (ref = content.SEO) === null || ref === void 0 ? void 0 : ref[0];
    const contentIntroText = renderWithResolver(intro);
    const isLoggedIn = userStatus === "valid";
    useEffect(()=>{
        handlePostAuthFavourite(addFavourite, isLoggedIn);
    }, [
        addFavourite,
        isLoggedIn
    ]);
    return /*#__PURE__*/ _jsxs(CompareBarProvider, {
        children: [
            /*#__PURE__*/ _jsx(Head, {
                ...SEO,
                generatedAt: generatedAt,
                fallbackTitle: "Electric cars - cinch",
                fallbackDescription: "Plug into the benefits of making your drive more electric, and choose from a wide range of electric cars to buy entirely online."
            }),
            /*#__PURE__*/ _jsxs("article", {
                className: styles.root,
                children: [
                    /*#__PURE__*/ _jsx(Wrapper, {
                        className: {
                            container: styles.electricCarsWrapper
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ _jsx(EvIntro, {
                            introText: contentIntroText
                        })
                    }),
                    /*#__PURE__*/ _jsx(Wrapper, {
                        className: {
                            container: styles.electricCarsWrapper
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ _jsx(EvBenefits, {
                            evBenefits: benefitsOfAnElectricCar
                        })
                    }),
                    /*#__PURE__*/ _jsx(Wrapper, {
                        className: {
                            container: cx(styles.electricCarsWrapper, styles.sectionSpacer)
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ _jsx(ExploreEvs, {})
                    }),
                    /*#__PURE__*/ _jsx(Wrapper, {
                        className: {
                            container: cx(styles.electricCarsWrapper, styles.sectionSpacer)
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ _jsx(EvCharging, {
                            evCharging: evChargingContent
                        })
                    }),
                    /*#__PURE__*/ _jsx(Wrapper, {
                        className: {
                            container: styles.electricCarsWrapper
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ _jsx(EvRange, {
                            evRange: evRangeContent
                        })
                    }),
                    /*#__PURE__*/ _jsx(Wrapper, {
                        className: {
                            container: styles.electricCarsWrapper
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ _jsx(EvInfoCard, {
                            evInfo: didYouKnow
                        })
                    }),
                    /*#__PURE__*/ _jsx(Wrapper, {
                        className: {
                            container: styles.electricCarsWrapper
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ _jsx(EvFaqs, {
                            title: faqTitle,
                            faqs: faqs
                        })
                    }),
                    /*#__PURE__*/ _jsx(JargonBuster, {
                        jargonContent: evJargonContent
                    }),
                    /*#__PURE__*/ _jsx(EvPreFooter, {
                        evCta: evCta,
                        image: image
                    }),
                    /*#__PURE__*/ _jsx(SharedCompareBar, {})
                ]
            })
        ]
    });
}
export default FeatureElectricCars;
